import HousePercentIcon from './HousePercentIcon'

export default HousePercentIcon
